import { render, staticRenderFns } from "./CadastroCredenciadoFormulario.vue?vue&type=template&id=2d9c587a&scoped=true&lang=pug&"
import script from "./CadastroCredenciadoFormulario.vue?vue&type=script&lang=js&"
export * from "./CadastroCredenciadoFormulario.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCredenciadoFormulario.vue?vue&type=style&index=0&id=2d9c587a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c587a",
  null
  
)

export default component.exports